import { Order, OrdersTotalResponse } from 'graphql-api/baskets-api-interfaces';

export function reduceOrders({
  orders,
  totals,
}: {
  orders: Order[];
  totals: OrdersTotalResponse;
}): Order {
  if (orders.length < 2) return orders[0];

  return {
    ...orders[0],
    totalPriceNet: {
      ...totals.totalPriceNet,
    },
    confirmedQuantity: totals.confirmedQuantity,
    requestedQuantity: totals.requestedQuantity,
  };
}
